var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":"TaskList"}},[_c('router-view',{attrs:{"fetchable":_vm.fetchable}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }